/**
 * Canonical work type definitions - single source of truth for IDs.
 * Do not hardcode work type IDs elsewhere.
 */

export const WORK_TYPE_IDS = {
  NEW_CONSTRUCTION: 'baf60f909c13b8e98b035a026592f0b6',
  TENANT_IMPROVEMENT: 'fbb29002fc376f02f593577435444584',
  INTERIOR_RENOVATION: '89551c8ead2560f8b9cd428ac1762dc2',
  EXTERIOR_RENOVATION: '1e26d11140a3a34e9b8712bcc52f949a',
  DEMOLITION: '289805d6c02d94a424f7bea61568b88e',
  TEMPORARY: 'd5197d93c063a2b1e22d1630a39b7aef',
  OPEN_SPACE: 'c97b4abc99b5a27d315cf1c55fbca049',
  SIGNS: '5d637c668526d24fa32a61dbe17ff10f',
  UNCATEGORIZED: '5d31aa47fb4298e5f698d85aa890f120',
} as const;

/** Flat list for FilterToolbar - each work type as a separate option */
export const WORK_TYPE_OPTIONS = [
  { value: WORK_TYPE_IDS.NEW_CONSTRUCTION, label: 'New Construction' },
  { value: WORK_TYPE_IDS.TENANT_IMPROVEMENT, label: 'Tenant Improvement' },
  {
    value: WORK_TYPE_IDS.INTERIOR_RENOVATION,
    label: 'Interior Renovation/Alteration',
  },
  {
    value: WORK_TYPE_IDS.EXTERIOR_RENOVATION,
    label: 'Exterior Renovation/Alteration',
  },
  { value: WORK_TYPE_IDS.DEMOLITION, label: 'Demolition' },
  { value: WORK_TYPE_IDS.TEMPORARY, label: 'Temporary' },
  { value: WORK_TYPE_IDS.OPEN_SPACE, label: 'Open Space' },
  { value: WORK_TYPE_IDS.SIGNS, label: 'Signs' },
  { value: WORK_TYPE_IDS.UNCATEGORIZED, label: 'Uncategorized' },
];
